import styled from 'styled-components'

export const StyledListItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 28px;
  max-width: 400px;
  width: 100%;
`

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  overflow: hidden;
  width: 100%;

  svg {
    margin-bottom: 4px;
    margin-right: 5px;
  }
`
export const PoiName = styled.span`
  display: block;
  text-overflow: ellipsis;

  /* Required for text-overflow to do anything */
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`

export const DistanceWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  max-width: 400px;

  svg {
    margin-left: 0;
  }
`
export const DistanceName = styled.span`
  font-size: 12px;
  font-weight: 400;
  max-width: 400px;
  white-space: nowrap;
  margin-right: 2px;
`
